const FIELD_TYPE = {
  DATE: "DATE",
  INPUT: "INPUT",
  SELECT: "SELECT",
  CHECKBOX: "CHECKBOX",
  LIST: "LIST",
  RADIO: "RADIO",
  RADIO_BUTTON: "RADIO_BUTTON",
  COLOR: "COLOR",
  NUMBER: "NUMBER",
  AUTO_COMPLETE: "AUTO_COMPLETE",
  CURRENCY: "CURRENCY",
  CODE: "CODE",
  COMBO_BOX: "COMBO_BOX",
  TEXT_AREA: "TEXT_AREA",
  TIME: "TIME",
  BUTTON: "BUTTON",
  TRA_THUOC: "TRA_THUOC",
  ICON: "ICON",
  RADIO_CUSTOM: "RADIO_CUSTOM",
  DATE_PRE: "DATE_PRE",
  DATE_ON: "DATE_ON",
  DATE_DISABLE: "DATE_DISABLE",
  DATE_DISABLE_NO_DAY: "DATE_DISABLE-NO_DAY",
  NORMAL_CHECKBOX: "NORMAL_CHECKBOX",
  DATE_DAY_INPUT: "DATE_DAY_INPUT",
  MONTH: "MONTH",
  TEXTT_AREA_CUSTOM: "TEXTT_AREA_CUSTOM",
};

export { FIELD_TYPE };
